import script from "./AdminUsersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUsersPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminUsersPage.vue?vue&type=style&index=0&id=3c7d6a4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c7d6a4a"]])

export default __exports__